import React from "react";
import NotFound from "./components/notFound";
import ServerError from "./components/serverError";

const Error = err => {
  const { error } = err;

  if (error.request.status >= 400 && error.request.status <= 499) {
    return <NotFound />;
  }

  return <ServerError />;
};

export default Error;
